import { isWeb, isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import theme from "app/Theme/Theme";
import { Box, Loading } from "app/components/common";
import normalize from "app/utils/normalize";
import React from "react";
import SkeletonContent from "react-native-skeleton-content-nonexpo";

const firstLayout = [
  {
    flex: 1,
    maxWidth: 400,
    minWidth: isWebDesktop ? 400 : 0,
    overflow: "hidden",
    shadowColor: "shadow",
    shadowRadius: 10,
    shadowOpacity: 1,
    shadowOffset: {
      height: 4,
      width: 0,
    },
    paddingTop: theme.spacing.xm,
    paddingHorizontal: theme.spacing.sl,
    paddingBottom: theme.spacing.m,
    borderRadius: 16,
    position: "relative",
    backgroundColor: theme.colors["neutral.white"],
    marginBottom: theme.spacing.m,
    zIndex: 1,
    children: [
      {
        width: "100%",
        height: normalize(40),
      },
      {
        flex: 1,
        width: "100%",
        marginTop: theme.spacing.s,
        marginBottom: theme.spacing.s,
      },
    ],
  },
];

interface IProps {
  isLoading: boolean;
}

const FullScreenCardSkeleton = ({ isLoading }: IProps) => {
  if (isWeb) {
    return (
      <Box flex={1} width="100%" justifyContent="center" alignItems="center">
        <Loading size={35} />
      </Box>
    );
  }

  return (
    <SkeletonContent
      isLoading={isLoading}
      layout={firstLayout}
      containerStyle={{
        flex: 1,
        width: "100%",
        paddingHorizontal: theme.spacing.m,
        paddingBottom: theme.spacing.xl,
      }}
    />
  );
};

export default FullScreenCardSkeleton;
